import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/documentCategory/importer/documentCategoryImporterActions';

export default importerReducers(actions);
